import { render, staticRenderFns } from "./NotificationsPopup.vue?vue&type=template&id=2d2127f2&scoped=true"
import script from "./NotificationsPopup.vue?vue&type=script&lang=js"
export * from "./NotificationsPopup.vue?vue&type=script&lang=js"
import style0 from "./NotificationsPopup.vue?vue&type=style&index=0&id=2d2127f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2127f2",
  null
  
)

export default component.exports